export default __webpack_public_path__ + "static/media/3.bd1e7224.jpg";